import type {PayloadActionResponse, UUID} from 'src/typings';
import type {ModalDialogService} from 'shared/modal-dialogs';
import type {FinishedResponseInteractionService} from 'shared/services';
import type {RecordRow} from 'src/features/record-grid/lib/types';
import type {ReferencesDateSelectionModalModel, ReportReferenceReported} from './types';
import type {ReportReferencesDataService} from './report-references.data-service';
import {convertFieldTypeIdToFieldId} from 'shared/utils/record-field-utils';
import {exists} from 'shared/utils/custom-utils';
import {FOND_REFERENCE} from 'src/features/erp-sutor/sutor-fonds';
import ReferencesDateSelectionModal from './components/ReferencesDateSelectionModal.svelte';

export class ReportReferencesService {
    public static serviceName = 'reportReferencesService';

    /*@ngInject*/
    constructor(private finishedResponseInteractionService: FinishedResponseInteractionService,
                private reportReferencesDataService: ReportReferencesDataService,
                private modalDialogService: ModalDialogService) {
    }

    public async getTotalReported(reference: RecordRow): Promise<ReportReferenceReported> {
        try {
            return await this.reportReferencesDataService.getTotalReportedValues(reference.id);
        } catch (errorException) {
            this.finishedResponseInteractionService.showFailedResponseInToast(errorException);
            return null;
        }
    }

    public async uploadFilesWithFond(files: File[], fondId: number): Promise<UUID[]> {
        if (files.length === 0) {
            return [];
        }

        let selectedDate: string | null;

        try {
            const result = await this.modalDialogService.openModalWindowFromComponent<ReferencesDateSelectionModalModel, PayloadActionResponse<string | null>>(ReferencesDateSelectionModal, {files});
            selectedDate = result.payload;
        } catch {
            return [];
        }

        try {
            const actionResponse = await this.reportReferencesDataService.createFondRecordsUsingFiles(files, fondId, exists(selectedDate) ? {
                fieldEditRequests: [
                    {
                        id: convertFieldTypeIdToFieldId(FOND_REFERENCE.dateFieldId, [0, 0]),
                        setFieldValueRequest: {value: selectedDate}
                    }
                ]
            } : null);
            await this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
            return actionResponse.savedObject;
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            return [];
        }
    }
}